import {
  Component,
  ContentChild,
  DoCheck,
  Self,
  TemplateRef,
} from '@angular/core';
import { ErrorBoundaryService } from './error-boundary.service';

@Component({
  providers: [ErrorBoundaryService],
  selector: 'error-boundary',
  templateUrl: './error-boundary.component.html',
})
export class ErrorBoundaryComponent implements DoCheck {
  constructor(
    @Self() private readonly errorBoundaryService: ErrorBoundaryService,
  ) {}

  @ContentChild(TemplateRef, { static: false })
  template: TemplateRef<{}>;

  ngDoCheck() {
    this.errorBoundaryService.ngDoCheck();
  }
}
